import { render } from "./IndexItem.vue?vue&type=template&id=1b8835d8"
import script from "./IndexItem.vue?vue&type=script&lang=js"
export * from "./IndexItem.vue?vue&type=script&lang=js"

import "./IndexItem.vue?vue&type=style&index=0&id=1b8835d8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__